import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { app } from 'util/firebase';

const podPath = (shipmentId: string | number, name: string) =>
  `delivery_photos/${shipmentId}/WEB-${Date.now()}-${name}`;

const upload = async (path: string, data: Blob, contentType: string) => {
  const fileRef = ref(getStorage(app), path);
  await uploadBytes(fileRef, data, { contentType });
  return getDownloadURL(fileRef);
};

export const uploadPodImages = async (
  shipmentId: string | number,
  files: File[],
): Promise<string[]> =>
  Promise.all(
    files.map((file, index) =>
      upload(podPath(shipmentId, `${index}.jpg`), file, file.type),
    ),
  );

export default uploadPodImages;
